import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "footer" }

import {
  showEditChatTitleDialogue,
  editForm,
} from "@/components/Dialogues/useData/useDialogues";
import {
  dialogueList,
  renameDialogue,
} from "@/views/Home/useData/module/dialogue";

export default /*@__PURE__*/_defineComponent({
  __name: 'EditChatTitleDialogue',
  setup(__props) {

const endEdit = () => {
  showEditChatTitleDialogue.value = false;

  renameDialogue(editForm.index, editForm.content);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showEditChatTitleDialogue),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showEditChatTitleDialogue) ? (showEditChatTitleDialogue).value = $event : null)),
    width: "260",
    class: "custom",
    "align-center": "",
    center: "",
    "show-close": false,
    style: { '--el-border-radius-base': '16px' }
  }, {
    header: _withCtx(() => _cache[3] || (_cache[3] = [])),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          class: "cancel-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showEditChatTitleDialogue.value = false)),
          type: ""
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("取消 ")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "ok-btn",
          type: "primary",
          onClick: endEdit
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "修改对话名称", -1)),
        _withDirectives(_createElementVNode("input", {
          placeholder: "请输入对话名称",
          maxlength: "20",
          class: "input-content",
          type: "text",
          name: "",
          id: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editForm).content) = $event))
        }, null, 512), [
          [_vModelText, _unref(editForm).content]
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})